import { ReactComponent as InterruptedByUserIconSvg } from "../../images/command-hub/InterruptedByUserIcon.svg";
import { SvgIcon, SvgIconProps } from "@mui/material";

const InterruptedByUserIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon component={InterruptedByUserIconSvg} {...props} inheritViewBox />
);

export default InterruptedByUserIcon;
